import { Model, attr } from 'redux-orm';
import {createAction} from '@reduxjs/toolkit';

// =====ACTIONS=====
export const createPendingUser = createAction('models/pendingUsers/create');

// =====MODEL=====

class PendingUsers extends Model {
    static modelName = 'PendingUsers';

    static fields = {
        id: attr(),
        name: attr(),
        circleID: attr()
    };

    static reducer({ type, payload }, PendingUsers, session) {
        switch (type) {
        case createPendingUser.type: {

            if (payload.length === 0) {
                PendingUsers.delete();
            }

            else {
                payload.forEach(item => {

                    PendingUsers.upsert({
                        id: parseInt(item.user_id),
                        name: item.name,
                        circleID: parseInt(item.circle_id),
                    });
                });
            }

            break;
        }

        default:
            break;
        }
    }
}

export default PendingUsers;